<!-- =========================================================================================
    File Name: Error404.vue
    Description: 404 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-row min-h-screen">
    <div class="w-full">
      <header-public></header-public>
    </div>
    <div class="flex w-full bg-img py-16">
      <div
        class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
      >
        <img src="@/assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full" />
        <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">{{ $t('PaginaNoEncontrada') }}</h1>

        <router-link
          :to="{ name: 'homePublic' }"
          class="vs-component vs-button vs-button-primary vs-button-filled large text-white"
        >
          {{ $t('VolverHome') }}
        </router-link>
      </div>
    </div>
    <div class="w-full self-end">
      <footer-public></footer-public>
    </div>
  </div>
</template>
<script>
import HeaderPublic from '../../components/Public/Header';
import FooterPublic from '../../components/Public/Footer';

export default {
  components: {
    HeaderPublic,
    FooterPublic,
  },
  data () {
    return {};
  },
};
</script>

<style></style>
